<template>
  <resource-box name="仓库储备排行top10">
    <div class="bar-card" slot="content">
      <div ref="barRef" class="chart-container"></div>
    </div>
  </resource-box>
</template>

<script>
import * as echarts from 'echarts'
import ResourceBox from "@/views/ChinaMapData/components/common/resourceBox.vue";
import {getCompanyTop10, getStoreTop10} from "@/API/chinaMapApi/chinaMapApi";
export default {
  components:{
    ResourceBox
  },
  name: 'BarChart',
  data() {
    return {
      emptyImg: require('@/assets/recycling/index/empty.svg'),
      xAxisData: [],
      seriesData: [],
      fullNames: [], // 存储完整的名称用于 tooltip 显示
      chartInstance: null, // 存储 ECharts 实例
    };
  },
  mounted() { this.getTop10(); },
  watch:{
    '$store.state.chinaMap.companyId': {
      handler: function (val) {
        this.getTop10();
      },
    },
    '$store.state.chinaMap.timeId': {
      handler: function (val) {
        this.getTop10();
      },
    },
    '$store.state.chinaMap.currentlyMapAdcode': {
      handler: function (val) {
        this.getTop10();
      },
    },
  },
  methods: {
    async getTop10() {
      this.xAxisData = [];
      this.seriesData = [];
      this.fullNames = [];
      try {
        let params = {
          types: this.$store.state.chinaMap.dataType == 1 ? '1,3' : '2,3',
          companyId: this.$store.state.chinaMap.companyId,
          region: this.$store.state.chinaMap.currentlyMapAdcode,
          subId: this.$store.state.chinaMap.timeId,
        };
        const res = await getStoreTop10(params);
        if (res.code === 200 && res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            this.fullNames.push(item.name); // 保存完整名称
            this.xAxisData.push(this.truncateName(item.name)); // X 轴显示截断后的名称
            this.seriesData.push(item.count || 0);
          });
          this.initChart();
        } else {
          console.error('接口返回数据异常:', res);
          this.initEmptyChart(); // 数据为空时显示空状态
        }
      } catch (error) {
        console.error('请求失败:', error);
        this.initEmptyChart(); // 请求失败时显示空状态
      }
    },
    // 截断名称，超过指定长度则显示省略号
    truncateName(name, maxLength = 8) {
      if (!name) return '';
      return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
    },
    // 初始化空状态图表
    initEmptyChart() {
      // 先清空旧实例
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
      const chart = echarts.init(this.$refs.barRef);
      this.chartInstance = chart;
      const option = {
        title: {
          text: '暂无数据',
          left: 'center',
          top: '75%',
          padding: [10, 20, 10, 20],
          textStyle: {
            color: '#909399',
            fontSize: 14,
            fontWeight: 'normal',
          },
        },
        graphic: {
          type: 'image',
          id: 'empty-icon',
          left: 'center',
          top: '25%',
          style: {
            image: this.emptyImg,
            width: 150,
            height: 150,
            opacity: 1,
          },
          bounding: 'content',
        },
        xAxis: { show: false },
        yAxis: { show: false },
        grid: { left: 0, right: 0, bottom: 0, top: 0 },
        series: [],
        backgroundColor: 'transparent',
      };
      chart.setOption(option);
      window.addEventListener('resize', () => chart.resize());
    },
    initChart() {
      // 先清空旧实例
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
      const chart = echarts.init(this.$refs.barRef)
      this.chartInstance = chart;
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: (params) => {
            // 自定义 tooltip，显示完整名称
            const dataIndex = params[0].dataIndex;
            const fullName = this.fullNames[dataIndex] || '';
            const value = params[0].value || 0;
            return `${fullName}<br/>储备量：${value}`;
          }
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '3%', // 增大底部边距，容纳更多标签
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          axisLine: { lineStyle: { color: 'rgba(255,255,255,0.2)' } },
          axisLabel: {
            color: '#fff',
            rotate: 45, // 旋转 45 度避免重叠
            interval: 0, // 强制显示所有标签
            fontSize: 11, // 调整字体大小
            margin: 10, // 标签与轴线的距离
          }
        },
        yAxis: {
          type: 'value',
          name: '单位 (吨)',
          nameTextStyle: {
            color: '#fff',
          },
          axisLine: { lineStyle: { color: 'rgba(255,255,255,0.2)' } },
          axisLabel: {
            color: '#fff',
            fontSize: 11,
            formatter: (value) => {
              // Y 轴数值格式化，超过 1000 显示为 k 单位
              if (value >= 1000) {
                return (value / 1000).toFixed(0) + 'k';
              }
              return value;
            }
          },
          splitLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } }
        },
        series: [{
          name: '储备量',
          type: 'bar',
          data: this.seriesData,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0,0,0,1, [
              { offset: 0, color: '#4DE2A8' },
              { offset: 1, color: '#105C3E' }
            ]),
            borderRadius: [4,4,0,0]
          },
          barWidth: '35%', // 调整柱状图宽度适配 10 条数据
          label: {
            show: true,
            position: 'top',
            color: '#fff',
            fontSize: 10,
            formatter: (params) => {
              return params.value !== null && params.value !== undefined ? params.value : '';
            }
          }
        }],
        backgroundColor: 'transparent'
      }
      chart.setOption(option)
      window.addEventListener('resize', () => chart.resize())
    },
  }
}
</script>

<style scoped>
.bar-card {
  border-radius: 8px;
  width: 100%;
  height: 100%;
  padding: 16px;
  flex: 1;
}
.chart-container {
  width: 100%;
  height: 100%;
}
</style>
